import { stripHtmlFromInput } from '@lib/formatting.utils'

const Q_EDITOR_MIXIN = {
  computed: {
    Q_EDITOR_MIXIN_fonts() {
      return {
        arial: 'Arial',
        arial_black: 'Arial Black',
        comic_sans: 'Comic Sans MS',
        courier_new: 'Courier New',
        impact: 'Impact',
        lucida_grande: 'Lucida Grande',
        times_new_roman: 'Times New Roman',
        verdana: 'Verdana'
      }
    },

    Q_EDITOR_MIXIN_toolbarSettings() {
      return [
        ['removeFormat', 'bold', 'italic', 'underline', 'hr', 'link'],
        [
          {
            label: this.$q.lang.editor.defaultFont,
            icon: this.$q.iconSet.editor.font,
            fixedIcon: true,
            list: 'no-icons',
            options: [
              'default_font',
              'arial',
              'arial_black',
              'comic_sans',
              'courier_new',
              'impact',
              'lucida_grande',
              'times_new_roman',
              'verdana'
            ]
          },
          {
            icon: this.$q.iconSet.editor.fontSize,
            fixedLabel: true,
            fixedIcon: true,
            list: 'no-icons',
            options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7']
          }
        ],
        ['unordered', 'ordered'],
        ['left', 'center', 'right', 'justify'],
        ['undo', 'redo']
      ]
    }
  },

  methods: {
    Q_EDITOR_MIXIN_onPaste(evt) {
      if (evt.target.nodeName === 'INPUT') return
      evt.preventDefault()

      let pastedData

      if (evt.clipboardData?.getData) {
        const html = evt.clipboardData.getData('text/html')
        const text = evt.clipboardData.getData('text')

        pastedData = html || text
      } else if (evt.originalEvent?.clipboardData?.getData) {
        const html = evt.originalEvent.clipboardData.getData('text/html')
        const text = evt.originalEvent.clipboardData.getData('text')

        pastedData = html || text
      }

      const strippedHtml = stripHtmlFromInput(pastedData)
      this.$refs.editor.runCmd('insertHtml', strippedHtml)
    }
  }
}
export default Q_EDITOR_MIXIN
